import {RulePart} from "./RulePart";
import {ICondition, ISearchParams} from "../../../../index";
import {IComboboxV2Options} from "../../../combobox/v2";
import {createServiceListPromise} from "../../../combobox/v2-sources";
import {lm} from "../../../../appContext";
import conditionHtml from './condition.html?raw';

export let template = conditionHtml;

export class viewModel extends RulePart {
    private getComboboxParams(): IComboboxV2Options<ICondition> {
        const listSource = createServiceListPromise<ICondition>({
            name: 'getconditions',
            params: {} as ISearchParams,
        })
        return {
            inputAttrs: {placeholder: lm.t('choose|td')},
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            onSelect: o => this.ruleMutable.argumentoperator(o?.name ?? null),
            initialMatch: o => o.name == this.ruleMutable.argumentoperator(),
            option: {
                label: o => lm.t('condition.' + o.name) ?? '',
            },
        }
    }
}
